export default {
      id: "life-cover-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#life-cover",
      toString: function () {
        return this.url;
      }
    }